import styled from "styled-components";
import logo from "../../assets/logo.png";

export const Container = styled.header`
  background-color: #141515;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;

export const Logo = styled.img.attrs({
  src: logo,
})``;

export const Label = styled.span`
  display: block;
  padding: 8px 16px;
  border-left: 1px #a7cf3e solid;
`;
